import React from "react";
import { t } from "@auto/services";

import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";

import styles from "../../ElectoralGeographyPage.module.styl";

const GeographyHeader = ({ loading }) => {
  return (
    <section className={styles.header}>
      <div className={styles.headerMain}>
        <div className={styles.heroIconWrap}>
          <AccountTreeOutlinedIcon className={styles.heroIcon} />
        </div>

        <div className={styles.headerText}>
          <h1>{t("geo.title")}</h1>
          <div>{t("geo.subtitle")}</div>
        </div>
      </div>

      <div className={styles.headerStatus}>
        {loading ? <span className={styles.loadingPill}>{t("common.loading.short")}</span> : null}
      </div>
    </section>
  );
};

export default GeographyHeader;
